(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["aeeyaa-atc-motion"] && !Shopify.designMode) return;
  try {
    (() => {
  const root = document.documentElement;

  if (root.dataset.aeeyaaAtcMotionInitialized === 'true') {
    return;
  }

  root.dataset.aeeyaaAtcMotionInitialized = 'true';

  const selector = '#MainContent .hdt-main-product-form .hdt-product-form__submit[name="add"]';
  const boundButtons = new WeakSet();
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  const bindButton = (button) => {
    if (boundButtons.has(button)) {
      return;
    }

    boundButtons.add(button);

    let isVisible = false;
    let readyTimer;

    const playReady = () => {
      window.clearTimeout(readyTimer);

      if (
        reduceMotion.matches ||
        !isVisible ||
        button.disabled ||
        button.getAttribute('aria-busy') === 'true' ||
        button.dataset.aeeyaaAtcAnimated === 'true'
      ) {
        return;
      }

      readyTimer = window.setTimeout(() => {
        if (
          !isVisible ||
          button.disabled ||
          button.getAttribute('aria-busy') === 'true' ||
          button.dataset.aeeyaaAtcAnimated === 'true'
        ) {
          return;
        }

        button.dataset.aeeyaaAtcAnimated = 'true';
        button.classList.add('aeeyaa-atc-ready');
      }, 220);
    };

    button.addEventListener('animationend', (event) => {
      if (event.animationName === 'aeeyaa-atc-ready') {
        button.classList.remove('aeeyaa-atc-ready');
      }

      if (event.animationName === 'aeeyaa-atc-success') {
        button.classList.remove('aeeyaa-atc-success');
      }
    });

    const formWrapper = button.closest('wrapp-hdt-pr-frm');

    formWrapper?.addEventListener('variant:add', () => {
      window.clearTimeout(readyTimer);
      button.dataset.aeeyaaAtcAnimated = 'true';
      button.classList.remove('aeeyaa-atc-ready');
      button.classList.add('aeeyaa-atc-success');

      window.setTimeout(() => {
        button.classList.remove('aeeyaa-atc-success');
      }, 700);
    });

    const buttonStateObserver = new MutationObserver(playReady);
    buttonStateObserver.observe(button, {
      attributes: true,
      attributeFilter: ['disabled', 'aria-busy']
    });

    if ('IntersectionObserver' in window) {
      const visibilityObserver = new IntersectionObserver((entries) => {
        isVisible = entries[0]?.isIntersecting === true && entries[0].intersectionRatio >= 0.72;

        if (isVisible) {
          playReady();
        } else {
          window.clearTimeout(readyTimer);
        }
      }, {
        threshold: [0.72]
      });

      visibilityObserver.observe(button);
    } else {
      isVisible = true;
      playReady();
    }
  };

  const bindAll = () => {
    document.querySelectorAll(selector).forEach(bindButton);
  };

  bindAll();

  const mainContent = document.getElementById('MainContent');

  if (mainContent) {
    const contentObserver = new MutationObserver(bindAll);
    contentObserver.observe(mainContent, {
      childList: true,
      subtree: true
    });
  }

  document.addEventListener('shopify:section:load', bindAll);
})();
  } catch(e) { console.error(e); }
})();

})();
